//存放或获取各种常量

export const strandedFalseAlarm = {
  0: '正常',
  1: '误报',
}
export const strandedSmsStatus = {
  0: '不需要发送',
  1: '发送成功',
  2: '发送失败',
}
export const strandedLevel = {
  1: '系统告警',
  2: '系统告警+短信告警',
  3: '系统告警+短信告警+黑名单拉黑',
}
export const batchApplicationStatus = {
  0: '暂存',
  1: '待执行导入',
  2: '导入成功',
  3: '导入失败',
}
export const processType = {
  1: '人员黑白名单添加、注销',
  2: '车辆黑名单添加、注销',
  3: '人员预约',
  4: '车辆预约',
  5: '严管车辆备案',
  6: '严管车辆预约',
  7: '车辆预约批量导入',
  8: '人员预约批量导入',
}
export const personGateCrossingType = {
  1: '进门',
  2: '出门',
  3: '进/出门',
}
export const gateCrossingVisitType = {
  1: '内部人员',
  2: '访客',
}
export const gateCrossingCardType = {
  '-1': '空白卡',
  0: '正常卡',
  1: '挂失卡',
  2: '注销卡',
}
export const gateCrossingType = {
  8: '入园',
  9: '出园',
}
export const gateCrossingState = {
  0: '未开闸等待命令开闸',
  1: '白名单已开闸',
}
export const gateCrossingResult = {
  0: '失败',
  1: '成功',
}
export const inOrOut = {
  inCounts: '入园',
  outCounts: '出园',
}
export const yesOrNot = {
  0: '否',
  1: '是',
}
export const loginState = {
  0: '失败',
  1: '成功',
}
export const approvalOperation = {
  1: '添加',
  2: '撤销',
}
export const publishState = {
  0: '未发布',
  1: '已发布',
}
export const gender = {
  0: '男',
  1: '女',
}
export const cargoType = {
  0: '普货',
  1: '危货',
}
export const blackWhiteListType = {
  1: '黑名单',
  2: 'VIP名单',
}
export const resultOptions = {
  1: '通过',
  2: '不通过',
}
export const processResultOptions = {
  1: '通过',
  2: '不通过',
  3: '超时未审批自动通过',
}
export const processState = {
  0: '待审批',
  1: '已审批',
  2: '用户撤销',
}

export const areaTypeConst = {
  1: '石化区',
  2: '惠州港',
}

//各种映射表
export const allEnum = [
  'status',
  'areaType',
  'gateType',
  'driverType',
  'delayedType',
  'expiredType',
  'documentType',
  'carVisitType',
  'entrancesType',
  'plateColorType',
  'personVisitType',
  'vehicleColorType',
  'blackWhiteListType',
  'stateEquipmentType',
  { name: 'label/type', value: 'labelType' },
  { name: 'label/color', value: 'labelColor' },
  { name: 'label/status', value: 'labelStatus' },
  { name: 'label/alarmType', value: 'labelAlarmType' },
]

//单词首字母大写
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
